import * as ApiHelper from "../../api/ApiHelper";
import { type PreviewItem } from "../models";
import { type PreviewItemDTO } from "../dtos";
import { transformPreviewItem } from "../transformers";
import { resolveApiUrl } from "../../utils/url/urlResolver";

export interface Result {
  products: PreviewItem[];
  error?: {
    reason: string;
    params: string[];
  };
}

const apiUrl = resolveApiUrl("/bulkupload/upload");
export type EndpointResponse = PreviewItemDTO[] | { reason: string; params: string[] };

export function sendData(csv: string): Promise<Result> {
  const data = new FormData();
  data.append("csvInputString", csv);

  const params: RequestInit = {
    body: data,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  };

  return fetch(apiUrl, params)
    .then((res) => res.json())
    .then((json: EndpointResponse) => {
      if (Array.isArray(json)) {
        return {
          products: json.map(transformPreviewItem),
        };
      } else {
        return {
          error: json,
          products: [],
        };
      }
    });
}
